import { ILlmPayload } from '../interfaces';
import { LlmConversationNode } from './llm-conversation-node';

/**
 * Wraps `ILlmConversationNode` for visually rendering the history tree
 */
export class LlmHistoryNode<T extends ILlmPayload = ILlmPayload> extends LlmConversationNode<T> {

	public override readonly children: LlmHistoryNode<ILlmPayload>[];

	public showChildren: boolean = true;

	public isVisible: boolean = true;

	public row: int = 0;

	public column: int = 0;

	public parent?: LlmHistoryNode;

	public constructor(_node?: Partial<LlmHistoryNode<T>>) {
		super(_node);

		this.showChildren = true;
		this.children = _node?.children?.map((_child: Partial<LlmHistoryNode>) =>
			new LlmHistoryNode({
				..._child,
				parent: this,
			})
		) ?? [];
	}

	public static setCollapsed(_node: LlmHistoryNode, _collapsed: Set<string>, _visible: boolean): void {
		if (!_node)
			return;

		_node.showChildren = !_collapsed.has(_node.nodeId);
		_node.isVisible = _visible;
		_node.children?.forEach((_child: LlmHistoryNode) => LlmHistoryNode.setCollapsed(_child, _collapsed, _visible && _node.showChildren));
	}

	public static setPosition(_node: LlmHistoryNode, _row: int, _column: int): number {
		_node.row = _row;
		_node.column = _column;

		if (!_node.children.length || !_node.showChildren) {
			if (_node.children.length && !_node.showChildren)
				LlmHistoryNode.collapseChildren(_node, _row, _column);

			return _column + 1;
		}

		for (const _child of _node.children)
			_column = LlmHistoryNode.setPosition(_child, _row + 1, _column);

		return _column;
	}

	public static collapseChildren(_node: LlmHistoryNode, row: int, column: int): void {
		_node.row = row;
		_node.column = column;
		_node.children.forEach((_child: LlmHistoryNode) =>
			LlmHistoryNode.collapseChildren(_child, row, column)
		);
	}

}
